import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M4.083 3.417h.154a.75.75 0 0 0 0-1.5h-.644c-.585 0-1.01.481-1.01 1.02v2.389c0 1.638 1.029 3.13 2.525 3.512v2.131c0 1.866 1.732 3.173 3.605 3.173 1.87 0 3.606-1.31 3.606-3.173V9.35c.827-.3 1.43-1.08 1.43-2.016 0-1.202-.993-2.147-2.18-2.147-1.187 0-2.18.945-2.18 2.147 0 .936.602 1.716 1.43 2.016v1.62c0 .812-.824 1.673-2.106 1.673-1.285 0-2.105-.857-2.105-1.673V8.842c1.505-.376 2.541-1.872 2.541-3.516v-2.39c0-.545-.436-1.02-1.01-1.02h-.61a.75.75 0 0 0 0 1.5h.12v1.91c0 1.25-.88 2.107-1.783 2.107-.902 0-1.783-.857-1.783-2.107v-1.91Zm6.806 3.916c0-.341.288-.647.68-.647.392 0 .68.306.68.647a.664.664 0 0 1-.68.647.664.664 0 0 1-.68-.647Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function l(s, d) {
  return e(), c("svg", o, [...r]);
}
const v = { render: l };
export {
  v as default,
  l as render
};
